import { createTheme } from "@mui/material/styles";

export const MobileNavBarTheme = ({ palette }) =>
    createTheme({
        palette,
        components: {
            MuiPaper: {
                styleOverrides: {
                    root: {
                        zIndex: "1200"
                    }
                }
            },
            MuiBottomNavigationAction: {
                styleOverrides: {
                    root: {
                        minWidth: "60px"
                    },
                    label: {
                        whiteSpace: "nowrap",
                        fontWeight: "500",
                        "&.Mui-selected": {
                            fontSize: "0.75rem"
                        }
                    }
                }
            },
            MuiBottomNavigation: {
                styleOverrides: {
                    root: {
                        height: "77px"
                    }
                }
            }
        }
    });
